import { getContext } from 'svelte';
import type { CartIconContext } from '../createCartIconContext/createCartIconContext';
import { Contexts } from '#lib/constants/contexts.js';

export const ALL = 'all';

export const getCartIconContext = () => {
	return getContext<CartIconContext>(Contexts.ShowCartCheckout);
};
